// PCとSPを切り替えるブレイクポイント
export const breakpoint = 900;
export const containerID = 'c-ilady';
export const assets_path = '/manage/wp-content/themes/ilady/assets/';